import SoundOff from './src/sound-off-combined';
export default SoundOff;